import { render, staticRenderFns } from "./OutboxNewLetter.vue?vue&type=template&id=5f1a8c2c"
import script from "./OutboxNewLetter.vue?vue&type=script&lang=js"
export * from "./OutboxNewLetter.vue?vue&type=script&lang=js"
import style0 from "./OutboxNewLetter.vue?vue&type=style&index=0&id=5f1a8c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports